import { render, staticRenderFns } from "./create-flow.vue?vue&type=template&id=11754175&scoped=true"
import script from "./create-flow.vue?vue&type=script&lang=js"
export * from "./create-flow.vue?vue&type=script&lang=js"
import style0 from "./create-flow.vue?vue&type=style&index=0&id=11754175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11754175",
  null
  
)

export default component.exports